// extracted by mini-css-extract-plugin
export default {"div":"ReponseQCM_div__KSdKD","form":"ReponseQCM_form__k1Yw8","btn":"ReponseQCM_btn__oOcNc"};